export const REFERRAL_APP_API_URL =
  process.env.VUE_APP_REFERRAL_APP_API_URL || "https://cabackend.xinshu.pro/api/referral-app";

export const SEALOS_HOSPITAL_API_URL =
  process.env.VUE_APP_SEALOS_HOSPITAL_API_URL || "https://cabackend.xinshu.pro/api/sealos/hospital";
